import React, { useCallback, useEffect, useState } from 'react'
import { PageTitle } from '../../../../../_metronic/layout/core'
import CurrencySelect from '../../components/common/CurrencySelect'
import RefreshSelect from '../Dashboard/components/RefreshSelect'
import { readStoredInterval } from '../Dashboard/components/useDashboardPolling'
import { CURRENCY_STORAGE_KEY, DEFAULT_CURRENCY, REFRESH_STORAGE_KEY } from '../Dashboard/core/consts'
import PayoutPoolFillChart from './components/PayoutPoolFillChart'

// PageTitle keys its effect on the breadcrumbs prop identity — the constant must be
// module-level, a fresh [] re-renders the page in a loop.
const NO_BREADCRUMBS: never[] = []

// Страница графиков состояния мэтчинга. Валюта и интервал обновления общие с
// «Обзором» (те же ключи хранилища). Опрос самоперепланируемый: следующий тик
// ставится от конца загрузки, а не по setInterval.
const MatchingChartsPage: React.FC = () => {
  const [currency, setCurrencyState] = useState<string>(
    () => localStorage.getItem(CURRENCY_STORAGE_KEY) || DEFAULT_CURRENCY
  )
  const [currencies, setCurrencies] = useState<string[]>([])
  const [intervalMs, setIntervalMsState] = useState<number>(readStoredInterval)
  const [refreshToken, setRefreshToken] = useState(0)
  const [lastUpdated, setLastUpdated] = useState<number | null>(null)

  const setCurrency = (c: string) => {
    localStorage.setItem(CURRENCY_STORAGE_KEY, c)
    setCurrencyState(c)
  }
  const setIntervalMs = (ms: number) => {
    localStorage.setItem(REFRESH_STORAGE_KEY, String(ms))
    setIntervalMsState(ms)
  }

  const onLoaded = useCallback((list: string[]) => {
    if (list.length) setCurrencies(list)
    setLastUpdated(Date.now())
  }, [])

  // Keep selection valid: if the stored currency isn't served, fall back.
  useEffect(() => {
    if (currencies.length && !currencies.includes(currency)) {
      setCurrencyState(currencies.includes(DEFAULT_CURRENCY) ? DEFAULT_CURRENCY : currencies[0])
    }
  }, [currencies, currency])

  useEffect(() => {
    if (!intervalMs || lastUpdated === null) return
    const timer = setTimeout(() => {
      // A hidden tab skips the request but keeps the loop alive.
      if (document.hidden) setLastUpdated(Date.now())
      else setRefreshToken((t) => t + 1)
    }, intervalMs)
    return () => clearTimeout(timer)
  }, [intervalMs, lastUpdated])

  return (
    <>
      <PageTitle breadcrumbs={NO_BREADCRUMBS}>Состояние мэтчинга</PageTitle>

      <div className='d-flex justify-content-end mb-3'>
        <div className='d-flex align-items-center gap-4'>
          <CurrencySelect
            currencies={currencies.length ? currencies : [currency]}
            value={currency}
            onChange={setCurrency}
          />
          <RefreshSelect
            intervalMs={intervalMs}
            setIntervalMs={setIntervalMs}
            lastUpdated={lastUpdated}
            onRefresh={() => setRefreshToken((t) => t + 1)}
          />
        </div>
      </div>

      <PayoutPoolFillChart currency={currency} refreshToken={refreshToken} onLoaded={onLoaded} />
    </>
  )
}

export default MatchingChartsPage
